import { FC } from 'react';

import { Badge } from '../../../components/ui/Badge';
import { Order } from '../../../types';

type Props = {
    order: Order;
};

const formatCents = (amountCents: number) =>
    new Intl.NumberFormat('uk-UA', {
        style: 'currency',
        currency: 'UAH',
    }).format(amountCents / 100);

const statusPresentation = (order: Order) => {
    if (order.service_fee_status === 'paid') {
        return { label: 'Сплачено', variant: 'success' as const };
    }
    if (order.service_fee_status === 'cancelled') {
        return { label: 'Скасовано', variant: 'neutral' as const };
    }

    return {
        label:
            order.status === 'completed'
                ? 'Очікує оплати'
                : 'Буде списано після завершення',
        variant: 'warning' as const,
    };
};

export const OrderServiceFeeStatus: FC<Props> = ({ order }) => {
    const amountCents = order.service_fee_cents || 0;
    if (amountCents <= 0) return null;

    const presentation = statusPresentation(order);

    return (
        <div className="mb-3 rounded-xl border bg-muted/20 p-3 text-sm">
            <div className="flex items-center justify-between gap-3">
                <span className="text-muted-foreground">
                    Сервісний збір CartOn
                </span>
                <span className="font-semibold">
                    {formatCents(amountCents)}
                </span>
            </div>
            <div className="mt-1 flex items-center justify-between gap-3">
                <span className="text-muted-foreground">Статус збору</span>
                <Badge variant={presentation.variant}>
                    {presentation.label}
                </Badge>
            </div>
        </div>
    );
};
